import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const googleLogin = () => {
    const redirect = encodeURIComponent(`${window.location.origin}/admin`);
    window.location.href = `https://auth.emergentagent.com/?redirect=${redirect}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A3F2F] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/" className="inline-block" data-testid="login-brand-link">
            <span className="font-serif-brand text-4xl font-semibold text-[#FAFAF8]">Green</span>
          </Link>
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059] mt-2">Professional Salon &amp; Academy</p>
        </div>
        <form onSubmit={submit} data-testid="login-form"
          className="bg-white rounded-md p-8 shadow-[0_20px_60px_rgba(0,0,0,0.25)]">
          <h1 className="font-serif-brand text-2xl font-semibold text-[#1C1C1C] mb-1">Admin Login</h1>
          <p className="text-[#5C6A63] text-sm mb-8">Sign in to manage your salon.</p>
          {error && (
            <div data-testid="login-error" className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-md px-4 py-3 mb-5">{error}</div>
          )}
          <label className="block text-xs font-semibold uppercase tracking-wider text-[#5C6A63] mb-2">Email</label>
          <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-[#E5E7E5] rounded-md px-4 py-3 text-sm mb-5 focus:ring-2 focus:ring-[#0A3F2F]/50 focus:outline-none"
            placeholder="admin@greensalon.com" />
          <label className="block text-xs font-semibold uppercase tracking-wider text-[#5C6A63] mb-2">Password</label>
          <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-[#E5E7E5] rounded-md px-4 py-3 text-sm mb-8 focus:ring-2 focus:ring-[#0A3F2F]/50 focus:outline-none"
            placeholder="••••••••" />
          <button type="submit" disabled={loading} data-testid="login-submit-btn"
            className="btn-lift w-full bg-[#0A3F2F] text-white font-semibold py-3 rounded-full text-sm hover:bg-[#0d5540] disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
          <div className="flex items-center gap-3 my-5">
            <span className="flex-1 h-px bg-[#E5E7E5]" />
            <span className="text-xs text-[#5C6A63] uppercase tracking-wider">or</span>
            <span className="flex-1 h-px bg-[#E5E7E5]" />
          </div>
          <button type="button" onClick={googleLogin} data-testid="google-login-btn"
            className="btn-lift w-full border border-[#E5E7E5] bg-white text-[#1C1C1C] font-semibold py-3 rounded-full text-sm hover:border-[#0A3F2F] flex items-center justify-center gap-3">
            <svg className="w-4 h-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Sign in with Google
          </button>
        </form>
        <p className="text-center text-white/50 text-xs mt-6">
          <Link to="/" className="hover:text-white transition-colors" data-testid="back-to-site-link">← Back to website</Link>
        </p>
      </div>
    </div>
  );
}
